document.addEventListener("DOMContentLoaded", function () {

    const siteHeader = document.getElementById("siteHeader");
    const mobileMenu = document.getElementById("siteMobileMenu");
    const toggleBtn = document.getElementById("siteMenuToggle");
    const panels = document.getElementById("mobilePanels");
    const subList = document.getElementById("mobileSubList");
    const subTitle = document.getElementById("mobileSubTitle");
    const backBtn = document.getElementById("mobileBackBtn");

    const announcementBar = document.querySelector(".announcement-bar");

    /* ── PERFECT menu top calculation ── */
    function updateMenuTop() {

        let top = 0;

        if (siteHeader) {
            const headerRect = siteHeader.getBoundingClientRect();
            top = headerRect.bottom; // ✅ always exact visible bottom
        }

        mobileMenu.style.top = top + "px";
    }

    updateMenuTop();

    // resize
    window.addEventListener("resize", updateMenuTop);

    // scroll (smooth + accurate)
    window.addEventListener("scroll", () => {
        requestAnimationFrame(updateMenuTop);
    });

    // announcement bar dynamic height (multi-line fix)
    if (announcementBar) {
        const observer = new ResizeObserver(() => {
            updateMenuTop();
        });
        observer.observe(announcementBar);
    }

    /* ── Open / Close Mobile Menu ── */

    function openMenu() {
        updateMenuTop();
        mobileMenu.classList.add("active");
        document.body.classList.add("menu-open");
    }

    function closeMenu() {
        mobileMenu.classList.remove("active");
        document.body.classList.remove("menu-open");
        setTimeout(() => panels.classList.remove("show-sub"), 310);
    }

    if (toggleBtn) {
        toggleBtn.addEventListener("click", () => {
            mobileMenu.classList.contains("active") ? closeMenu() : openMenu();
        });
    }

    /* ── Desktop dropdown ── */

/* ── RESET active on load ── */
// window.addEventListener("DOMContentLoaded", () => {
//     document.querySelectorAll(".site-nav-list").forEach(li => {
//         li.classList.remove("active"); // 👈 ye main fix hai
//     });
// });


/* ── Desktop dropdown ── */
    // const desktopItems = document.querySelectorAll(".site-nav-list.site-has-dropdown");

    // document.querySelectorAll(".site-dropdown-toggle").forEach(btn => {

    //     btn.addEventListener("click", function (e) {

    //         e.preventDefault();

    //         const parent = this.closest(".site-has-dropdown");
    //         const wasActive = parent.classList.contains("dropdownactive");

    //         desktopItems.forEach(i => i.classList.remove("dropdownactive"));

    //         if (!wasActive) parent.classList.add("dropdownactive");

    //     });

    // });

    // document.addEventListener("click", function (e) {

    //     if (!e.target.closest(".site-nav-list")) {
    //         desktopItems.forEach(i => i.classList.remove("dropdownactive"));
    //     }

    // });

    /* ── Search Overlay ── */

    const searchOverlay = document.getElementById("siteSearchOverlay");
    const searchClose = document.getElementById("siteSearchClose");

    if (searchClose) {
        searchClose.addEventListener("click", () => {
            searchOverlay.classList.remove("active");
            document.body.classList.remove("search-open");
        });
    }

    ["siteSearchOpen","stickysiteSearchOpen", "siteSearchOpenMobile"].forEach(id => {

        const el = document.getElementById(id);

        if (el) {

            el.addEventListener("click", function (e) {

                e.stopPropagation();
                searchOverlay.classList.add("active");
                document.body.classList.add("search-open");

                const input = searchOverlay.querySelector("input");

                if (input) input.focus();

            });

        }

    });

    /* ── Sub-menu drill-down ── */

    document.querySelectorAll(".mobile-menu-btn").forEach((btn) => {

        btn.addEventListener("click", function () {

            const dataScript = this.parentElement.querySelector(".submenu-data");
            if (!dataScript) return;

            const data = JSON.parse(dataScript.textContent);

            buildSubMenu(data, 1);

        });

    });

    function buildSubMenu(data, level) {

        subTitle.textContent = data.title;

        let html = "";

        data.children.forEach(item => {

            if (item.children && item.children.length > 0) {
                html += `
                    <li>
                        <button class="mobile-sub-btn">
                            ${item.title}
                            <span class="mobile-arrow">
                                <svg viewBox="0 0 14 10" fill="none">
                                    <path d="M8.537.808l4 4-4 4" stroke="currentColor"/>
                                </svg>
                            </span>
                        </button>

                        <div class="nested-data" style="display:none;">
                            ${JSON.stringify(item)}
                        </div>
                    </li>
                `;
            } else {
                html += `<li><a href="${item.url}">${item.title}</a></li>`;
            }

        });

        subList.innerHTML = html;

        panels.classList.add("show-sub");

        document.querySelectorAll(".mobile-sub-btn").forEach(btn => {

            btn.addEventListener("click", function () {

                const nested = JSON.parse(
                    this.parentElement.querySelector(".nested-data").textContent
                );

                buildSubMenu(nested, 2);

            });

        });

    }

    if (backBtn) {
        backBtn.addEventListener("click", () => panels.classList.remove("show-sub"));
    }

    /* ── Header scroll behavior ── */

    let lastY = window.scrollY;

    window.addEventListener("scroll", () => {

        const currentY = window.scrollY;
        const diff = currentY - lastY;

        // if (currentY <= 80) {
        //     siteHeader.classList.remove("header-hidden");
        // }
        // else if (diff > 4) {
        //     siteHeader.classList.add("header-hidden");
        // }
        // else if (diff < -4) {
        //     siteHeader.classList.remove("header-hidden");
        // }

        lastY = currentY;

    }, { passive: true });

    /* ── Body scroll class ── */

    window.addEventListener("scroll", function () {

        if (window.scrollY > 50) {
            document.body.classList.add("scrolled");
        }
        else {
            document.body.classList.remove("scrolled");
        }

    });

    /* ── Nested dropdown ── */

    document.querySelectorAll(".site-dropdown .nested-toggle").forEach(function (toggle) {
        toggle.addEventListener("click", function (e) {
            e.preventDefault();
            e.stopPropagation();

            var parentLi = this.closest(".has-nested");
            var isOpen = parentLi.classList.contains("nest-open");

            document.querySelectorAll(".has-nested.nest-open").forEach(function (el) {
                el.classList.remove("nest-open");
            });

            if (!isOpen) parentLi.classList.add("nest-open");
        });
    });

    // Header Sticky

    // const mainHeader = document.querySelector(".site-header-main:not(.sticky-header)");
    // const stickyHeader = document.querySelector(".site-header-main.sticky-header");
    // const header = document.querySelector('.header');

    // function handleScroll() {
       
    //         if (window.scrollY > 100) {
    //             mainHeader.style.display = "none";
    //             stickyHeader.style.display = "flex";
    //             stickyHeader.classList.add("show");
    //             header.classList.add("sticky");
    //         } else {
    //             mainHeader.style.display = "flex";
    //             stickyHeader.style.display = "none";
    //             stickyHeader.classList.remove("show");
    //             header.classList.remove("sticky");
    //         }
        
    // }

    // window.addEventListener("scroll", handleScroll);
    // window.addEventListener("resize", handleScroll);

    const mainHeader = document.querySelector(".site-header-main:not(.sticky-header)");
    const stickyHeader = document.querySelector(".site-header-main.sticky-header");
    const header = document.querySelector('.header');

    function handleScroll() {
        const isDesktop = window.innerWidth >= 992;

        if (isDesktop) {
            // Desktop
            if (window.scrollY > 100) {
                mainHeader.style.display = "none";
                stickyHeader.style.display = "flex";
                stickyHeader.classList.add("show");
                 header.classList.add("sticky");
            } else {
                mainHeader.style.display = "flex";
                stickyHeader.style.display = "none";
                stickyHeader.classList.remove("show");
                header.classList.remove("sticky");
            }
        } else {
            // Tablet & Mobile
            mainHeader.style.display = "flex";
            stickyHeader.style.display = "none";
            if (window.scrollY > 100) {
                mainHeader.classList.add("sticky");
                header.classList.add("sticky");
            } else {
                mainHeader.classList.remove("sticky");
                header.classList.remove("sticky");
            }
        }
    }

    window.addEventListener("scroll", handleScroll);
    window.addEventListener("resize", handleScroll);
    handleScroll();

});